import {onFind} from "@elements/init-modules-in-scope";
import {on} from '@elements/dom-utils'

import './scripts/common';

if (!window.HTMLPictureElement) {
    import('picturefill');
}

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

/**********************************
 *
 *      Project Stuff
 *
 * ********************************/

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import * as ajaxFormExtend from './scripts/ajax-form-extend';
ajaxFormExtend.init();

import * as floatingLabels from '@elements/floating-labels';
floatingLabels.init();

import * as fetchModal from './scripts/fetch-modal';
fetchModal.init();